import React, { useEffect, useState, useContext } from "react"
import Flatpickr from "react-flatpickr"

import {
  Col,
  Row,
  Card,
  CardBody,
  Container,
  Label,
  Input,
  InputGroup,
  Form,
  FormFeedback,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  Spinner,
  CardFooter,
} from "reactstrap"

import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import { Editor } from "@tinymce/tinymce-react"

import classnames from "classnames"

import { checkScope } from "helpers/utility_helper"

// Formik Validation
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import _ from "lodash"
import fn_helper from "helpers/fn_helper"
import ModalContext from "../../contexts/ModalContext"
import UploadFileAPI from "components/UploadFileAPI"
import InputLang from "components/Input/InputLang"
import moment from "moment"
import MyEditor from "components/MyEditor"
import UploadFileS3 from "components/UploadFileS3"
import InputAttachment from "components/Input/attachment/InputAttachment"
import PopupAttachment from "components/Input/attachment/PopupAttachment"
import UploadDesc from "components/UploadDesc"
import { ReactSortable } from "react-sortablejs"
import Sortable from "sortablejs"
import Spinners from "components/Common/Spinner"
import { slugify } from "helpers/fn_helper"

// Services
import {
  SearchPageSetting,
  SavePageSetting,
  UpdatePageSetting,
} from "../../services/api/module/PageSetting.js"
import {
  UpdateContent,
  CreateContent,
  GetContentById,
} from "./services/Services"
import Error401 from "components/Error401"
import InputText from "components/Input/InputText"

const STATUS_OPTION = fn_helper.OPTIONS.STATUS

const _routeLink = `organization-possibilities/page-setting`
const _pageName = `Organization Possibilities`
const _routePermission = `organization-possibilities:projects-list`

const OrganizationPossibilitiesContentSettingTemplate = ({
  pageView = "create",
  componentKey = "",
}) => {
  // POPUP
  const { mAlert } = useContext(ModalContext)

  // OTHER STATE
  const qParams = useParams()
  const qLang = _.upperCase(qParams?.lang) ?? "TH"
  const qMainId = 1
  const navigate = useNavigate()

  const [waitSendData, setWaitSendData] = useState(false)
  const [contentLoading, setContentLoading] = useState(false)

  // ========== Form Validation ========== //
  const validationSchema = Yup.object({
    // contentName: Yup.string().required("Please Enter News Name1"),
    // contentName2: Yup.string().required("Please Enter News Name2"),
    // slug: Yup.string().max(255).required("Please Enter Slug"),

    contentDetail: Yup.string().required(
      "Please Enter Please Enter Title deatil"
    ),
    // contentSeoTitle: Yup.string(),
    // contentSeoKeyword: Yup.string().max(1024),
    // contentSeoDescription: Yup.string().max(1024),

    contentUpdateDate: Yup.string()
      .max(100)
      .required("Please Select Written at"),
    contentStatus: Yup.string().max(100).required("Please Enter Display"),
  })

  // LOCAL STATE FORM
  const [updatedValidationSchema, setUpdatedValidationSchema] =
    useState(validationSchema)

  const initialValues = {
    contentId: "",

    // Content
    contentName: "",
    contentName2: "",
    // slug: "",
    contentLinkout: "",
    contentLinkout2: "",
    contentLinkout3: "",
    partnerTitle: "",
    titleLink1: "",
    linkUrl1: "",
    titleLink2: "",
    linkUrl2: "",
    contentDetail: "",
    bannerDesktop: {},
    bannerMobile: {},
    vdo: {},
    partnerImage: {},

    contentSeoTitle: "",
    contentSeoKeyword: "",
    contentSeoDescription: "",
    contentUpdateDate: moment().format("YYYY-MM-DD"),
    contentStatus: "active",

    slug: "",
    contentPageName: "",
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: updatedValidationSchema,
    onSubmit: values => {
      console.log("🚀 ~ ExecutivesPageCreate ~ values:", values)
      let payload = {
        id: qMainId,
        contentId: values.contentId ? values.contentId : undefined,
        langId: qLang,
        contentName: values.contentName,
        contentDetail: values.contentDetail,
        vdoDetail: values.vdoDetail,
        partnerTitle: values.partnerTitle,
        titleLink1: values.titleLink1,
        linkUrl1: values.linkUrl1,
        titleLink2: values.titleLink2,
        linkUrl2: values.linkUrl2,

        contentUpdateDate: values.contentUpdateDate,
        contentStatus: values.contentStatus,

        contentAttachmentData: {
          vdo: values.vdo,
          partnerImage: values.partnerImage,
        },
      }

      setWaitSendData(true)

      if (pageView === "update") {
        API.fetchUpdateContentPageSetting(payload)
      } else {
        API.fetchCreateContent(payload)
      }
    },
  })

  // const preFilInput = (resData = {}) => {
  //     // console.log("🚀 ~ preFilInput ~ resData:", resData)
  //     // resetForm(validation.values, initialValues)

  //     // ถ้าไม่หน่วงมันจะแย่งกันทำ
  //     // validation.setFieldValue("contentId", resData?.contentId ?? "")
  //     // validation.setFieldValue("contentSitename", resData?.contentSitename ?? "")
  //     // validation.setFieldValue("contentDetail", resData?.contentDetail ?? "")
  //     // validation.setFieldValue("slug", resData?.slug ?? "")
  //     // validation.setFieldValue("bannerDesktop", resData?.contentAttachmentList?.find((obj) => obj.attachmentField == 'banner_desktop') ?? "")
  //     // validation.setFieldValue("bannerMobile", resData?.contentAttachmentList?.find((obj) => obj.attachmentField == 'banner_mobile') ?? "")
  //     // validation.setFieldValue("contentThumbnail", resData?.contentThumbnail ?? "")

  //     // validation.setFieldValue("contentSeoTitle", resData?.contentSeoTitle ?? "")
  //     // validation.setFieldValue("contentSeoKeyword", resData?.contentSeoKeyword ?? "")
  //     // validation.setFieldValue("contentSeoDescription", resData?.contentSeoDescription ?? "")
  //     // validation.setFieldValue("contentUpdateDate", resData?.contentUpdateDate ?? moment().format('YYYY-MM-DD'))
  //     // validation.setFieldValue("contentStatus", resData?.contentStatus ?? "active")

  // }

  const preFilInputPage = (resData = {}) => {
    console.log("🚀 ~ preFilInputPage ~ resData:", resData)
    // resetForm(validation.values, initialValues)
    // validation.setFieldValue("contentId", resData?.contentId ?? "")

    // validation.setFieldValue("contentPageName", resData?.contentPageName ?? "")
    // validation.setFieldValue("slug", resData?.slug ?? "")
    // validation.setFieldValue("bannerDesktop", resData?.contentAttachmentList?.find((obj) => obj.attachmentField == 'banner_desktop') ?? "")
    // validation.setFieldValue("bannerMobile", resData?.contentAttachmentList?.find((obj) => obj.attachmentField == 'banner_mobile') ?? "")
    // validation.setFieldValue("contentSeoTitle", resData?.contentSeoTitle ?? "")
    // validation.setFieldValue("contentSeoKeyword", resData?.contentSeoKeyword ?? "")
    // validation.setFieldValue("contentSeoDescription", resData?.contentSeoDescription ?? "")

    // validation.setFieldValue("contentUpdateDate", resData?.contentUpdateDate ?? moment().format('YYYY-MM-DD'))
    // validation.setFieldValue("contentStatus", resData?.contentStatus ?? "active")
  }

  const preFilInput = (resData = {}) => {
    console.log("🚀 ~ preFilInput ~ resData:", resData)
    // resetForm(validation.values, initialValues)

    // ถ้าไม่หน่วงมันจะแย่งกันทำ
    // validation.setFieldValue("contentId", resData?.contentId ?? "")
    // validation.setFieldValue("contentSitename", resData?.contentSitename ?? "")
    // validation.setFieldValue("slug", resData?.slug ?? "")
    // validation.setFieldValue("contentHeadline", resData?.contentHeadline ?? "")
    validation.setFieldValue("contentDetail", resData?.contentDetail ?? "")
    validation.setFieldValue("vdoDetail", resData?.vdoDetail ?? "")
    validation.setFieldValue("partnerTitle", resData?.partnerTitle ?? "")
    validation.setFieldValue("titleLink1", resData?.titleLink1 ?? "")
    validation.setFieldValue("linkUrl1", resData?.linkUrl1 ?? "")
    validation.setFieldValue("titleLink2", resData?.titleLink2 ?? "")
    validation.setFieldValue("linkUrl2", resData?.linkUrl2 ?? "")

    // console.log('resData.attachmentList.find(obj => obj.attachmentField == "banner_desktop"', resData.attachmentList.find(obj => obj.attachmentField == "banner_desktop"))

    validation.setFieldValue(
      "partnerImage",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField == "partner_image"
      ) ?? ""
    )
    validation.setFieldValue(
      "vdo",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField == "vdo"
      ) ?? ""
    )

    validation.setFieldValue(
      "contentUpdateDate",
      resData?.contentUpdateDate ?? moment().format("YYYY-MM-DD")
    )
    validation.setFieldValue(
      "contentStatus",
      resData?.contentStatus ?? "active"
    )

    // validation.setFieldValue("contentPageName", resData?.pageSettingRoute?.contentPageName ?? "")
    // validation.setFieldValue("slug", resData?.pageSettingRoute?.slug ?? "")
  }

  const API = {
    fetchGetContentPageSetting: async componentKey => {
      try {
        const response = await SearchPageSetting(componentKey, {
          lang: qLang,
        })
        const resData = response.data
        if (resData.status == 200) {
          preFilInputPage(resData.data)
        }
      } catch (err) {
        console.log("err ", err)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong 001",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setContentLoading(false)
      }
    },

    fetchGetContentById: async payload => {
      try {
        const response = await GetContentById({
          id: payload.id,
          lang: qLang,
        })
        const resData = response.data
        if (resData.status == 200) {
          preFilInput(resData.data)
        }
      } catch (err) {
        console.log("err ", err)
        qMainId = 0
        // mAlert.info({
        //     title: "Alert",
        //     subTitle: "Something went wrong 001",
        //     content: "",
        //     onClose: () => {
        //         //  alert("onClose")
        //     },
        // })
      } finally {
        setContentLoading(false)
      }
    },
    fetchCreateContent: async payload => {
      try {
        const response = await CreateContent({ data: payload, lang: qLang })
        const resData = response.data
        if (resData.status == 201) {
          mAlert.info({
            title: "Alert",
            subTitle: "Created Data Success",
            content: "",
            onClose: () => {
              // navigate(`/${_routeLink}/${qLang}/edit`)
              window.location.reload()
            },
          })
        }
      } catch (e) {
        console.log(e)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setWaitSendData(false)
      }
    },
    fetchUpdateContentPageSetting: async payload => {
      try {
        const response = await UpdateContent({
          data: payload,
          id: payload.id,
          lang: qLang,
        })
        const resData = response.data
        if (resData.error && resData.status == 406) {
          response = await CreateContent({ data: payload, lang: qLang })
          resData = response.data
          if (resData.status == 201) {
            mAlert.info({
              title: "Alert",
              subTitle: "Update Data Success",
              content: "",
              onClose: () => {
                // navigate(`/${_routeLink}/page/${qLang}/edit`)
                //window.location.reload()
              },
            })
          }
        } else if (resData.status == 202) {
          mAlert.info({
            title: "Alert",
            subTitle: "Update Data Success",
            content: "",
            onClose: () => {
              // navigate(`/${_routeLink}/page/${qLang}/edit`)
              //window.location.reload()
            },
          })
        }
      } catch (err) {
        console.log("err ", err)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setWaitSendData(false)
      }
    },
  }

  // กรณี Edit
  useEffect(() => {
    if (["update", "view"].includes(pageView)) {
      const payload = { id: qMainId }
      setContentLoading(true)
      API.fetchGetContentById(payload)
      // API.fetchGetContentPageSetting(componentKey)
    }
  }, [qLang])

  const PAGE_VIEW = _.capitalize(_.first(pageView) + pageView.slice(1))
  document.title =
    `${_pageName} | ${PAGE_VIEW} | ` + process.env.REACT_APP_CMS_TITLE

  const itemStyle = {
    padding: "10px",
    border: "1px solid black",
    margin: "5px",
    borderRadius: "8px",
    background: "#f9f9f9",
    transition: "transform 0.2s ease, background-color 0.3s ease",
  }

  // if (!checkScope(`${_routePermission}:create`) || !checkScope(`${_routePermission}:update`) || !checkScope(`${_routePermission}:view`)) {
  //     return <Error401 />
  // }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={`${PAGE_VIEW} Page Settings`}
            breadcrumbItems={[
              { title: "Page Settings", link: "" },
              { title: PAGE_VIEW },
            ]}
          />

          {/* Render Form */}
          {contentLoading ? (
            <Spinners setLoading={setContentLoading} />
          ) : (
            <Row>
              <Col className="col-12">
                <FormikProvider value={validation}>
                  <Form
                    className="form-horizontal"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col className="col-8">
                        <Card>
                          <h5 className="card-header bg-transparent border-bottom text-uppercase">
                            <i className="bx bx-cube-alt"></i> Information Box
                          </h5>
                          <CardBody>
                            <Row>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="contentDetail"
                                  className="col-md-12 col-form-label"
                                >
                                  Title Detail
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <MyEditor
                                    id="contentDetail"
                                    placeholder=""
                                    name="contentDetail"
                                    onChange={(e, editor) => {
                                      const data = editor.getData()
                                      validation.setFieldValue(
                                        "contentDetail",
                                        data
                                      )
                                      console.log({ e, editor, data })
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.contentDetail}
                                    invalid={
                                      validation.touched.contentDetail &&
                                      validation.errors.contentDetail
                                        ? true
                                        : false
                                    }
                                    disabled={pageView === "view"}
                                  />
                                  {validation.touched.contentDetail &&
                                    validation.errors.contentDetail && (
                                      <FormFeedback type="invalid">
                                        {validation.errors.contentDetail}
                                      </FormFeedback>
                                    )}
                                </div>
                                <hr />
                              </Col>
                              <Col className="col-12 mb-3">
                                <div className="col-md-12">
                                  <PopupAttachment
                                    typeDetail="single"
                                    typeUpload="VideoMP4"
                                    upload="Video"
                                    prefixName="page-vdo"
                                    label="VDO MP4"
                                    required={false}
                                    description="description"
                                    value={validation.values.vdo}
                                    onChange={(value = {}, index) => {
                                      console.log("🚀 onChange ~ value:", value)
                                      console.log("🚀 onChange ~ index:", index)
                                      validation.setFieldValue("vdo", value)
                                    }}
                                    onRemove={index => {
                                      console.log("🚀 onChange ~ index:", index)
                                      validation.setFieldValue("vdo", {})
                                    }}
                                  />
                                  {validation.touched.vdo &&
                                    validation.errors.vdo && (
                                      <div
                                        type="invalid"
                                        className="invalid-feedback d-block"
                                      >
                                        {validation.errors.vdo}
                                      </div>
                                    )}
                                </div>
                                <hr />
                              </Col>

                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="vdoDetail"
                                  className="col-md-12 col-form-label"
                                >
                                  VDO Detail
                                  {/* <span className="t-require">*</span> */}
                                </label>
                                <div className="col-md-12">
                                  <MyEditor
                                    id="vdoDetail"
                                    placeholder=""
                                    name="vdoDetail"
                                    onChange={(e, editor) => {
                                      const data = editor.getData()
                                      validation.setFieldValue(
                                        "vdoDetail",
                                        data
                                      )
                                      console.log({ e, editor, data })
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.vdoDetail}
                                    invalid={
                                      validation.touched.vdoDetail &&
                                      validation.errors.vdoDetail
                                        ? true
                                        : false
                                    }
                                    disabled={pageView === "view"}
                                  />
                                  {validation.touched.vdoDetail &&
                                    validation.errors.vdoDetail && (
                                      <FormFeedback type="invalid">
                                        {validation.errors.vdoDetail}
                                      </FormFeedback>
                                    )}
                                </div>
                                <hr />
                              </Col>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="partnerTitle"
                                  className="col-md-12 col-form-label"
                                >
                                  Partner Title
                                  {/* <span className="t-require">*</span> */}
                                </label>
                                <div className="col-md-12">
                                  <InputText
                                    id="partnerTitle"
                                    className="form-control"
                                    type="text"
                                    placeholder=""
                                    name="partnerTitle"
                                    onChange={e => {
                                      validation.setFieldValue(
                                        "partnerTitle",
                                        e.target.value
                                      )
                                      // validation.setFieldValue("contentSeoTitle", e.target.value)
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.partnerTitle}
                                    invalid={
                                      validation.touched.partnerTitle &&
                                      validation.errors.partnerTitle
                                        ? true
                                        : false
                                    }
                                    disabled={pageView === "view"}
                                    maxLength={9999}
                                  />
                                  {validation.touched.partnerTitle &&
                                    validation.errors.partnerTitle && (
                                      <FormFeedback type="invalid">
                                        {validation.errors.partnerTitle}
                                      </FormFeedback>
                                    )}
                                </div>
                                <hr />
                              </Col>

                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="titleLink1"
                                  className="col-md-12 col-form-label"
                                >
                                  Title LinkOut 1
                                  {/* <span className="t-require">*</span> */}
                                </label>
                                <div className="col-md-12">
                                  <Input
                                    id="titleLink1"
                                    className="form-control"
                                    type="text"
                                    placeholder=""
                                    name="titleLink1"
                                    onChange={e => {
                                      validation.setFieldValue(
                                        "titleLink1",
                                        e.target.value
                                      )
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.titleLink1}
                                    invalid={
                                      validation.touched.titleLink1 &&
                                      validation.errors.titleLink1
                                        ? true
                                        : false
                                    }
                                    disabled={pageView === "view"}
                                  />
                                  {validation.touched.titleLink1 &&
                                    validation.errors.titleLink1 && (
                                      <FormFeedback type="invalid">
                                        {validation.errors.titleLink1}
                                      </FormFeedback>
                                    )}
                                </div>
                                <hr />
                              </Col>

                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="linkUrl1"
                                  className="col-md-12 col-form-label"
                                >
                                  Link Url 1
                                  {/* <span className="t-require">*</span> */}
                                </label>
                                <div className="col-md-12">
                                  <InputText
                                    id="linkUrl1"
                                    className="form-control"
                                    type="text"
                                    placeholder=""
                                    name="linkUrl1"
                                    onChange={e => {
                                      validation.setFieldValue(
                                        "linkUrl1",
                                        e.target.value
                                      )
                                      // validation.setFieldValue("contentSeoTitle", e.target.value)
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.linkUrl1}
                                    invalid={
                                      validation.touched.linkUrl1 &&
                                      validation.errors.linkUrl1
                                        ? true
                                        : false
                                    }
                                    disabled={pageView === "view"}
                                    maxLength={9999}
                                  />
                                  {validation.touched.linkUrl1 &&
                                    validation.errors.linkUrl1 && (
                                      <FormFeedback type="invalid">
                                        {validation.errors.linkUrl1}
                                      </FormFeedback>
                                    )}
                                </div>
                                <hr />
                              </Col>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="titleLink2"
                                  className="col-md-12 col-form-label"
                                >
                                  Title Link 2
                                  {/* <span className="t-require">*</span> */}
                                </label>
                                <div className="col-md-12">
                                  <Input
                                    id="titleLink2"
                                    className="form-control"
                                    type="text"
                                    placeholder=""
                                    name="titleLink2"
                                    onChange={e => {
                                      validation.setFieldValue(
                                        "titleLink2",
                                        e.target.value
                                      )
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.titleLink2}
                                    invalid={
                                      validation.touched.titleLink2 &&
                                      validation.errors.titleLink2
                                        ? true
                                        : false
                                    }
                                    disabled={pageView === "view"}
                                  />
                                  {validation.touched.titleLink2 &&
                                    validation.errors.titleLink2 && (
                                      <FormFeedback type="invalid">
                                        {validation.errors.titleLink2}
                                      </FormFeedback>
                                    )}
                                </div>
                                <hr />
                              </Col>

                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="linkUrl2"
                                  className="col-md-12 col-form-label"
                                >
                                  Link Url 2
                                  {/* <span className="t-require">*</span> */}
                                </label>
                                <div className="col-md-12">
                                  <InputText
                                    id="linkUrl2"
                                    className="form-control"
                                    type="text"
                                    placeholder=""
                                    name="linkUrl2"
                                    onChange={e => {
                                      validation.setFieldValue(
                                        "linkUrl2",
                                        e.target.value
                                      )
                                      // validation.setFieldValue("contentSeoTitle", e.target.value)
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.linkUrl2}
                                    invalid={
                                      validation.touched.linkUrl2 &&
                                      validation.errors.linkUrl2
                                        ? true
                                        : false
                                    }
                                    disabled={pageView === "view"}
                                    maxLength={9999}
                                  />
                                  {validation.touched.linkUrl2 &&
                                    validation.errors.linkUrl2 && (
                                      <FormFeedback type="invalid">
                                        {validation.errors.linkUrl2}
                                      </FormFeedback>
                                    )}
                                </div>
                                <hr />
                              </Col>
                              <Col className="col-12 mb-3">
                                <div className="col-md-12">
                                  <PopupAttachment
                                    typeDetail="single"
                                    typeUpload="ImageMap"
                                    upload="Image"
                                    prefixName="page-partnerImage"
                                    label="Partner Image BG"
                                    required={false}
                                    description="description"
                                    widthSize={2160}
                                    heightSize={672}
                                    value={validation.values.partnerImage}
                                    onChange={(value = {}, index) => {
                                      console.log("🚀 onChange ~ value:", value)
                                      console.log("🚀 onChange ~ index:", index)
                                      validation.setFieldValue(
                                        "partnerImage",
                                        value
                                      )
                                    }}
                                    onRemove={index => {
                                      console.log("🚀 onChange ~ index:", index)
                                      validation.setFieldValue(
                                        "partnerImage",
                                        {}
                                      )
                                    }}
                                  />
                                  {validation.touched.partnerImage &&
                                    validation.errors.partnerImage && (
                                      <div
                                        type="invalid"
                                        className="invalid-feedback d-block"
                                      >
                                        {validation.errors.partnerImage}
                                      </div>
                                    )}
                                </div>
                                <hr />
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>

                      <Col className="col-4">
                        <Card
                          outline
                          color="primary"
                          className="border sticky-element"
                        >
                          <h5 className="card-header bg-transparent border-bottom text-primary text-uppercase">
                            <i className="bx bx-check"></i> Tools Box
                          </h5>
                          <CardBody>
                            <Row>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="category_name"
                                  className="col-md-12 col-form-label"
                                >
                                  Switch Language
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <InputLang
                                    widthfull
                                    pageView={pageView}
                                    forceRoute={false}
                                  />
                                </div>
                              </Col>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="category_name"
                                  className="col-md-12 col-form-label"
                                >
                                  Written at
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <InputGroup>
                                    <Flatpickr
                                      className="form-control d-block"
                                      options={{
                                        dateFormat: "d/m/Y", // กำหนดรูปแบบวันที่ เช่น 15/08/1997
                                      }}
                                      value={
                                        validation.values.contentUpdateDate
                                          ? moment(
                                              validation.values
                                                .contentUpdateDate,
                                              "YYYY-MM-DD"
                                            ).toDate()
                                          : null
                                      }
                                      disabled={true}
                                    />
                                    <div className="input-group-append">
                                      <button
                                        type="button"
                                        className="btn btn-outline-secondary docs-datepicker-trigger"
                                        disabled
                                      >
                                        <i
                                          className="fa fa-calendar"
                                          aria-hidden="true"
                                        />
                                      </button>
                                    </div>
                                  </InputGroup>
                                  {validation.touched.contentUpdateDate &&
                                    validation.errors.contentUpdateDate && (
                                      <div
                                        type="invalid"
                                        className="invalid-feedback d-block"
                                      >
                                        {validation.errors.contentUpdateDate}
                                      </div>
                                    )}
                                </div>
                              </Col>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="category_name"
                                  className="col-md-12 col-form-label"
                                >
                                  Display
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <Select
                                    placeholder="Select Status"
                                    value={fn_helper.FNFORM.getObjectValue(
                                      STATUS_OPTION,
                                      `${validation.values.contentStatus}`
                                    )}
                                    onChange={value =>
                                      validation.setFieldValue(
                                        "contentStatus",
                                        value.id
                                      )
                                    }
                                    getOptionValue={option => option.id}
                                    getOptionLabel={option => option.name}
                                    options={STATUS_OPTION}
                                    className={`select2-selection ${
                                      validation.touched.contentStatus &&
                                      validation.errors.contentStatus
                                        ? "input-err"
                                        : ""
                                    }`}
                                    isDisabled={pageView === "view"}
                                  />
                                  {validation.touched.contentStatus &&
                                    validation.errors.contentStatus && (
                                      <div
                                        type="invalid"
                                        className="invalid-feedback d-block"
                                      >
                                        {validation.errors.contentStatus}
                                      </div>
                                    )}
                                </div>
                              </Col>
                            </Row>
                          </CardBody>
                          <CardFooter>
                            <Row>
                              <Col className="text-start">
                                <Button
                                  color="danger"
                                  className="btn btn-danger"
                                  onClick={() =>
                                    // /what-we-do/highlight-card-list/:cardId/:lang
                                    navigate(`/${_routeLink}/${qLang}`)
                                  }
                                >
                                  Back
                                </Button>
                              </Col>
                              <Col className="text-end">
                                {pageView !== "view" && (
                                  <Button
                                    type="submit"
                                    className="btn btn-success"
                                  >
                                    Save{" "}
                                    {waitSendData ? (
                                      <Spinner size="sm" color="light" />
                                    ) : null}
                                  </Button>
                                )}
                              </Col>
                            </Row>
                          </CardFooter>
                        </Card>
                      </Col>
                    </Row>
                  </Form>
                </FormikProvider>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

// QuestionaireCategory.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(
  OrganizationPossibilitiesContentSettingTemplate
)
